import { X } from "lucide-react";
import { Button } from "./Button.js";

/* The clear control a `clearable` field renders beside its trigger or input
   while a value is set — DatePicker's and Combobox's one copy. Internal: not
   in the barrel. A ghost iconOnly Button size="xs" (24x24) — the same recipe
   NumberInput's StepButtons use, and the WCAG 2.2 2.5.8 minimum target. Kept
   in its own file so neither field's main file grows around it. */

interface FieldClearButtonProps {
  readonly clearLabel: string;
  readonly onClear: () => void;
}

export function FieldClearButton({
  clearLabel,
  onClear,
}: FieldClearButtonProps) {
  return (
    <Button
      variant="ghost"
      iconOnly
      size="xs"
      aria-label={clearLabel}
      onClick={onClear}
    >
      <X aria-hidden className="w-3.5 h-3.5" />
    </Button>
  );
}
